import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);

document.addEventListener('DOMContentLoaded', () => {

    if (document.querySelector('.identity-hover')) {
        const identityTextElements = document.querySelectorAll('.identity-hover .elementor-flip-box__layer__description');
        identityTextElements.forEach((text) => {
            const citationText = text.innerHTML.split('|', -1)[0];
            const authorCitationText = text.innerHTML.split('|', -1)[1];
            text.innerHTML = citationText + '<span>' + authorCitationText + '</span>';
        });
    }

});

(function ($) {
    $(document).ready(function () {

        const body = document.querySelector('body');
        if (body.classList.contains('archive') || body.classList.contains('single-projects') || body.classList.contains('page-template-projects')) {
            const blogLiElement = document.querySelector('#menu-menu-header-right li:first-of-type');
            blogLiElement.firstElementChild.style.overflow = 'hidden';
            const projectsLiElement = document.querySelector('#menu-menu-header-left li:last-of-type');
            projectsLiElement.classList.add('current_page_parent');
            blogLiElement.classList.remove('current_page_parent');
        }


        //LooseMobile home section

        if (window.innerWidth < 768) {
            if (document.body.classList.contains('home')) {
                const looseImgElement = document.querySelector('.section-equipments .equipments-block .image img');
                looseImgElement.src = looseImgElement.dataset.mobile;
                looseImgElement.style.marginTop = '40px';
            }
        }

        //sliders
        const swiperHome = new Swiper('.swiper', {
            slidesPerView: 1,
            allowTouchMove: true,
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 50,
                },
            },
            speed: 400,
            navigation: {
                nextEl: '.swiper-btn-next',
                prevEl: '.swiper-btn-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            on: {
                slideChange() {
                    if (document.querySelector('.discover')) {
                        const titleElement = document.querySelector('.discover');
                        if (this.activeIndex !== 0) {
                            titleElement.style.opacity = '0';
                        } else {
                            titleElement.style.opacity = '1';
                        }
                    } else if (document.querySelector('.swiper > .title')) {
                        const titleHomeElement = document.querySelector('.swiper > .title');
                        if (this.activeIndex !== 0) {
                            titleHomeElement.style.opacity = '0';
                        } else {
                            titleHomeElement.style.opacity = '1';
                        }
                    }
                },
            },
        });
        const swiperArticles = new Swiper('.swiper-articles', {
            slidesPerView: '1',
            spaceBetween: 15,
            loop: true,
            breakpoints: {
                640: {
                    slidesPerView: '2',
                },
                992: {
                    slidesPerView: '3',
                },
                1100: {
                    slidesPerView: '4',
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });
        if ($(window).width() < 769) {
            let swiperProjectsHome = new Swiper('.section-projects .wrapper', {
                slidesPerView: 1.1,
                loop: false,
                wrapperClass: 'row',
                slideClass: 'column-card',
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        spaceBetween: 20
                    },
                    // when window width is >= 640px
                    640: {
                        spaceBetween: 40
                    }
                }

            });
        }
        ;
        if ($(window).width() < 769) {
            let swiperBlogHome = new Swiper('#posts-blog .wrapper', {
                slidesPerView: 1.1,
                loop: false,
                wrapperClass: 'row',
                slideClass: 'blog-post',
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        spaceBetween: 20
                    },
                    // when window width is >= 640px
                    640: {
                        spaceBetween: 40
                    }
                }

            });
        }
        ;
        // prev / next tout choupi
        if (window.innerWidth > 768) {
            document.querySelectorAll('.swiper-btn').forEach((swiperbtn) =>
                swiperbtn.addEventListener('mousemove', (e) => {
                    const span = swiperbtn.children[0];
                    span.style.left = e.offsetX + 'px';
                    span.style.top = e.offsetY + 'px';
                    swiperbtn.classList.add('custo-cur-on');
                })
            );
            document.querySelectorAll('.swiper-btn').forEach((swiperbtn) =>
                swiperbtn.addEventListener('mouseleave', () => {
                    swiperbtn.classList.remove('custo-cur-on');
                })
            );
        }

        $('.close-search').on('click', function () {
            $('#search-block').removeClass('open');
        });
        $('.open-search').on('click', function () {
            $('#search-block').addClass('open');
            $('#search-field').focus();
        });
        $('#toggle-icon').on('click', function () {
            $('.mobile-menu').addClass('toggled');
        });
        $('.cross-close').on('click', function () {
            $('.mobile-menu').removeClass('toggled');
        });

        $('.btn-load-more').click(function () {
            $('.more-loaded').slideToggle();
        });

        $('.more-post-blog').click(function () {
            $('.see-more').hide();
            $('.see-more-active').slideToggle(300, function () {
                $(this).css('display', 'block');
            });
        });

        // pour Fancybox
        $('.wp-block-gallery a[href$=".jpg"], .wp-block-gallery a[href$=".jpeg"], .wp-block-gallery a[href$=".png"], .wp-block-gallery a[href$=".gif"]').each(function () {
            const $_this = $(this);
            if ($_this.next('figcaption').length) {
                $_this.attr('data-caption', $_this.next('figcaption').text());
            }
        });

        const heightDiscorver = $('.single-projects .swiper-slide .discover').outerHeight();
        const heightProject = $('.single-projects .swiper-slide .discover .default-title').outerHeight();
        const heightNameProject = $('.single-projects .swiper-slide .discover h1').outerHeight();
        const heightImageProject = $('.single-projects .swiper-slide img').outerHeight();

        const caclheight = heightNameProject + 5;
        const caclheight1 = heightNameProject + 50;

        const calc = 'calc( 0px - ' + caclheight + 'px)';
        const calc1 = 'calc(' + heightImageProject + 'px + ' + caclheight1 + 'px)';

        $('.single-projects .swiper-slide .discover').css({bottom: calc});
        $('.single-projects .swiper-container').css({height: calc1});

        // Fancybox à la demande :)
        $('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], [data-fancybox]').on('click', function () {
            if (typeof Fancybox !== 'function') {
                // Fancybox n'existe pas : on charge le JS et le CSS
                const fancy_script = document.createElement('script');
                fancy_script.setAttribute('src', stylesheet_directory_uri + 'dist/fancybox.umd.js');
                document.head.appendChild(fancy_script);
                const fancy_css = document.createElement('link');
                fancy_css.setAttribute('rel', 'stylesheet');
                fancy_css.setAttribute('href', stylesheet_directory_uri + 'dist/fancybox.css');
                document.head.appendChild(fancy_css);

                const $_this = $(this);

                // ayé c'est chargé ?
                fancy_script.addEventListener('load', function () {
                    Fancybox.bind('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], [data-fancybox]', {
                        groupAttr: 'data-mr-gal',
                    });

                    // elem du DOM (et pas jQuery)
                    $_this[0].click();
                });

                return false;
            }
        });
    });
}(window.jQuery));
